export default __webpack_public_path__ + "static/media/stteresa.8b12ea57.jpg";